import { render } from "./VolunteerSignUpWizard.vue?vue&type=template&id=22cbe09e&scoped=true"
import script from "./VolunteerSignUpWizard.vue?vue&type=script&lang=js"
export * from "./VolunteerSignUpWizard.vue?vue&type=script&lang=js"

import "./VolunteerSignUpWizard.vue?vue&type=style&index=0&id=22cbe09e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cbe09e"]])

export default __exports__